if (!customElements.get('lookbook-card')) {
  customElements.define(
    'lookbook-card',
    class LookbookCard extends ModalComponent {
      constructor() {
        super();

        this.card = this.closest('.lbcard');
        this._openedViaKeyboard = false;

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = () => {
          this.removeAttribute('open');
          document.body.classList.remove(this.classes.show);
        };
      }

      get isLockingNeeded() {
        return FoxTheme.config.mqlMobile;
      }

      get requiresBodyAppended() {
        return FoxTheme.config.mqlMobile;
      }

      connectedCallback() {
        super.connectedCallback();
        if (!this.open) {
          this._setClosedState();
        }
      }

      _setClosedState() {
        this.hidden = true;
        this.setAttribute('inert', '');
        this._manageInteriorFocusability(false);
      }

      _manageInteriorFocusability(enable) {
        const selector =
          'a[href], button:not([disabled]), input:not([type=hidden]):enabled, select:enabled, textarea:enabled, [tabindex]:not([tabindex^="-"])';

        this.querySelectorAll(selector).forEach((el) => {
          if (enable) {
            if (!el.hasAttribute('data-lbcard-tabindex')) return;
            const prev = el.getAttribute('data-lbcard-tabindex');
            el.removeAttribute('data-lbcard-tabindex');
            if (prev === '') el.removeAttribute('tabindex');
            else el.setAttribute('tabindex', prev);
            return;
          }

          if (el.hasAttribute('data-lbcard-tabindex')) return;
          el.setAttribute('data-lbcard-tabindex', el.getAttribute('tabindex') ?? '');
          el.setAttribute('tabindex', '-1');
        });
      }

      prepareToShow() {
        super.prepareToShow();
        this._manageInteriorFocusability(true);
        this.card.classList.add('is-open');
      }

      handleAfterShow() {
        if (this._openedViaKeyboard || this.isLockingNeeded) {
          this._openedViaKeyboard = false;
          super.handleAfterShow();
        }
      }

      handleAfterHide() {
        super.handleAfterHide();
        this._setClosedState();
        this.card.classList.remove('is-open');
      }
    }
  );
}

if (!customElements.get('lookbook-card-wrapper')) {
  customElements.define(
    'lookbook-card-wrapper',
    class LookbookCardWrapper extends HTMLElement {
      constructor() {
        super();
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onTriggerKeyDown = this.onTriggerKeyDown.bind(this);
      }

      get trigger() {
        return this.querySelector('.lbcard__popup-btn-trigger');
      }

      get video() {
        return this.querySelector('video-element');
      }

      get modal() {
        const id = this.getAttribute('aria-controls');
        return id ? document.getElementById(id) : null;
      }

      connectedCallback() {
        this.addEventListener('keydown', this.onKeyDown);

        const trigger = this.trigger;
        if (trigger) {
          trigger.addEventListener('keydown', this.onTriggerKeyDown);
        }

        if (this.video) {
          this.addEventListener('mouseleave', this.handleMouseInteraction.bind(this, 'leave'));
          this.addEventListener('mouseenter', this.handleMouseInteraction.bind(this, 'enter'));
        }

        const modal = this.modal;
        if (!modal) return;

        modal.addEventListener('toggle', () => {
          const isOpen = modal.hasAttribute('open');
          this.setAttribute('aria-expanded', isOpen);
          if (trigger) trigger.setAttribute('aria-expanded', isOpen);
        });
      }

      disconnectedCallback() {
        this.removeEventListener('keydown', this.onKeyDown);
        this.trigger?.removeEventListener('keydown', this.onTriggerKeyDown);
      }

      markKeyboardOpen() {
        const modal = this.modal;
        if (modal && !modal.open) {
          modal._openedViaKeyboard = true;
        }
      }

      onKeyDown(event) {
        if (event.defaultPrevented) return;
        if (event.target !== this) return;

        const isActivationKey =
          event.code === 'Enter' || event.code === 'Space' || event.key === 'Enter' || event.key === ' ';

        if (isActivationKey) {
          event.preventDefault();
          this.markKeyboardOpen();
          this.click();
        }
      }

      onTriggerKeyDown(event) {
        if (event.defaultPrevented) return;

        const isActivationKey =
          event.code === 'Enter' || event.code === 'Space' || event.key === 'Enter' || event.key === ' ';

        if (isActivationKey) {
          this.markKeyboardOpen();
        }
      }

      handleMouseInteraction(type, event) {
        if (type === 'enter') {
          this.classList.add('is-hovering');
          this.video.play();
        } else {
          this.classList.remove('is-hovering');
          this.video.pause();
        }
      }
    }
  );
}
